<mat-card class="module-card enterprise-card">
  <mat-card-header class="module-head page-head">
    <div class="module-title">
      <h2>{{ config.title }}</h2>
      <p>{{ moduleSubtitle() }}</p>
    </div>

    <div class="toolbar-actions toolbar-right">
      <button mat-stroked-button class="toolbar-btn alert-btn" type="button" *ngIf="resource === 'assignments'" [disabled]="submitting" (click)="sendAssignmentAlert()">
        <mat-icon>outgoing_mail</mat-icon>
        Send Alert
      </button>
      <button mat-flat-button color="primary" class="toolbar-btn primary-btn" type="button" *ngIf="config.canCreate" (click)="openCreate()">
        <mat-icon>add</mat-icon>
        {{ addButtonLabel() }}
      </button>
      <button mat-stroked-button class="toolbar-btn" type="button" *ngIf="config.canEdit" [disabled]="!selected" (click)="openEdit()">
        <mat-icon>edit</mat-icon>
        Edit
      </button>
      <button mat-stroked-button color="warn" class="toolbar-btn" type="button" *ngIf="config.canDelete" [disabled]="!selected" (click)="removeSelected()">
        <mat-icon>delete</mat-icon>
        Delete
      </button>
    </div>
  </mat-card-header>

  <mat-card-content>
    <div class="module-controls">
      <div class="toolbar-filters toolbar-center" *ngIf="hasDateFilter()">
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>Preset</mat-label>
          <mat-select [(ngModel)]="datePreset" (selectionChange)="applyPreset($event.value)">
            <mat-option value="" disabled hidden>Select date preset</mat-option>
            <mat-option value="today">Today</mat-option>
            <mat-option value="yesterday">Yesterday</mat-option>
            <mat-option value="last7">Last 7 Days</mat-option>
            <mat-option value="month">This Month</mat-option>
            <mat-option value="custom">Custom Range</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="range-field" subscriptSizing="dynamic">
          <mat-label>Date range</mat-label>
          <mat-date-range-input [rangePicker]="picker">
            <input matStartDate placeholder="Start" [(ngModel)]="rangeStart" (dateChange)="onRangeChange()" />
            <input matEndDate placeholder="End" [(ngModel)]="rangeEnd" (dateChange)="onRangeChange()" />
          </mat-date-range-input>
          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
        <button mat-stroked-button class="toolbar-btn" type="button" (click)="clearDateFilters()" style="margin-top: 7px;">
          <mat-icon>close</mat-icon>
          Clear
        </button>
      </div>

      <mat-form-field appearance="outline" class="search-field" subscriptSizing="dynamic">
        <mat-icon matPrefix>search</mat-icon>
        <input matInput [placeholder]="searchPlaceholder()" [ngModel]="quickFilter" (ngModelChange)="setQuickFilter($event)" />
      </mat-form-field>

      <!-- <button mat-stroked-button class="toolbar-btn filter-btn" type="button" *ngIf="resource === 'workers'">
        <mat-icon>filter_list</mat-icon>
        Filters
        <mat-icon>expand_more</mat-icon>
      </button> -->
    </div>

    <div class="error" *ngIf="error">{{ error }}</div>

    <div class="loader" *ngIf="loading">
      <mat-spinner diameter="42"></mat-spinner>
      <span>Loading data...</span>
    </div>

    <section class="overview-grid" *ngIf="!loading && dataSource.filteredData.length" aria-label="Module overview">
      <article class="overview-card" *ngFor="let card of overviewCards(); trackBy: trackByOverviewLabel" [ngClass]="'tone-' + card.tone">
        <span class="overview-icon"><mat-icon>{{ card.icon }}</mat-icon></span>
        <div class="overview-copy">
          <span>{{ card.label }}</span>
          <strong>{{ formatOverviewValue(card.value) }}</strong>
        </div>
        <small *ngIf="card.meta">{{ card.meta }}</small>
      </article>
    </section>

    <div class="empty-state" *ngIf="!loading && dataSource.filteredData.length === 0">
      <mat-icon>inbox</mat-icon>
      <div>No data available</div>
      <p>Try adjusting filters or create a new record.</p>
    </div>

    <div class="table-wrap" *ngIf="!loading && dataSource.filteredData.length">
      <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z0">
        <ng-container *ngFor="let column of tableColumns; let i = index" [matColumnDef]="'col' + i">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sticky>{{ column.headerName }}</th>
          <td mat-cell *matCellDef="let row">
            <span class="employee-cell" *ngIf="isWorkerNameColumn(column); else shiftCell">
              <span class="employee-avatar" [ngClass]="workerAvatarClass(row)">{{ workerInitials(row) }}</span>
              {{ getCellValue(column, row) }}
            </span>
            <ng-template #shiftCell>
              <span class="shift-chip" *ngIf="isWorkerShiftColumn(column); else skillCell" [ngClass]="shiftClass(getCellValue(column, row))">
                <mat-icon>{{ shiftClass(getCellValue(column, row)) === 'shift-night' ? 'nightlight' : 'wb_sunny' }}</mat-icon>
                {{ getCellValue(column, row) }}
              </span>
            </ng-template>
            <ng-template #skillCell>
              <span class="skill-chip" *ngIf="isWorkerSkillColumn(column); else statusCell" [ngClass]="skillClass(getCellValue(column, row))">
                {{ getCellValue(column, row) }}
              </span>
            </ng-template>
            <ng-template #statusCell>
              <span *ngIf="isStatusColumn(column) && hasCellValue(column, row); else normalCell" class="status-badge" [ngClass]="statusClass(getCellValue(column, row))">
                <mat-icon>{{ statusIcon(getCellValue(column, row)) }}</mat-icon>
                <span>{{ getCellValue(column, row) }}</span>
              </span>
            </ng-template>
            <ng-template #normalCell>{{ getCellValue(column, row) }}</ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions" *ngIf="resource === 'approvals'">
          <th mat-header-cell *matHeaderCellDef sticky>Actions</th>
          <td mat-cell *matCellDef="let row" class="row-actions">
            <button mat-flat-button color="primary" class="row-action-btn" *ngIf="row.status !== 'Rejected'" (click)="handleApprovalAction('approve', row)">
              <mat-icon>check</mat-icon>
              Approve
            </button>
            <button mat-flat-button color="warn" class="row-action-btn" *ngIf="row.status !== 'Rejected'" (click)="handleApprovalAction('reject', row)">
              <mat-icon>close</mat-icon>
              Reject
            </button>
            <button mat-stroked-button class="row-action-btn" *ngIf="row.status === 'Rejected'" (click)="handleApprovalAction('revert', row)">
              <mat-icon>undo</mat-icon>
              Revert
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="rowMenu" *ngIf="resource === 'workers'">
          <th mat-header-cell *matHeaderCellDef sticky></th>
          <td mat-cell *matCellDef="let row" class="row-menu-cell">
            <button mat-icon-button type="button" aria-label="Select employee" (click)="selectRow(row); $event.stopPropagation()">
              <mat-icon>more_vert</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          tabindex="0"
          [class.selected]="selected?._id === row._id"
          (click)="selectRow(row)"
          (keydown.enter)="selectRow(row)"
        ></tr>
      </table>
    </div>

    <div class="module-paginator" *ngIf="!loading && dataSource.filteredData.length">
      <span>{{ paginationLabel() }}</span>
      
      <div class="pager-buttons" aria-label="Table pagination">
        <mat-paginator
        [pageSize]="10"
        [pageSizeOptions]="[10, 25, 50, 100]"
        showFirstLastButtons
      ></mat-paginator>
        <button mat-icon-button type="button" [disabled]="!canPreviousPage()" (click)="firstPage()" aria-label="First page">
          <mat-icon>keyboard_double_arrow_left</mat-icon>
        </button>
        <button mat-icon-button type="button" [disabled]="!canPreviousPage()" (click)="previousPage()" aria-label="Previous page">
          <mat-icon>chevron_left</mat-icon>
        </button>
        <span class="page-number">{{ currentPage() }}</span>
        <button mat-icon-button type="button" [disabled]="!canNextPage()" (click)="nextPage()" aria-label="Next page">
          <mat-icon>chevron_right</mat-icon>
        </button>
        <button mat-icon-button type="button" [disabled]="!canNextPage()" (click)="lastPage()" aria-label="Last page">
          <mat-icon>keyboard_double_arrow_right</mat-icon>
        </button>
      </div>
    </div>
  </mat-card-content>
</mat-card>

<ng-template #recordDialog>
  <section class="record-dialog">
    <header class="record-dialog-head">
      <div>
        <span class="eyebrow">{{ formModel._id ? 'Edit record' : 'New record' }}</span>
        <h2>{{ formModel._id ? 'Edit' : 'Add' }} {{ config.title }}</h2>
      </div>
      <button mat-icon-button type="button" (click)="closeFormDialog()" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </header>

    <form class="record-form" (ngSubmit)="save()">
      <div class="record-dialog-body">
      <ng-container *ngFor="let field of visibleFields()">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" *ngIf="field.relation; else normalInput">
          <mat-label>{{ field.label }}</mat-label>
          <mat-select
            [(ngModel)]="formModel[field.key]"
            [name]="field.key"
            (selectionChange)="onFieldChange(field.key)"
            [required]="!!field.required"
            [disabled]="isRelationReadonly(field)"
          >
            <mat-option value="" disabled hidden>Select {{ field.label }}</mat-option>
            <mat-option *ngFor="let option of optionsFor(field)" [value]="option._id">{{ labelFor(field, option) }}</mat-option>
          </mat-select>
          <mat-error *ngIf="isFieldInvalid(field)">{{ fieldError(field) }}</mat-error>
        </mat-form-field>

        <ng-template #normalInput>
          <mat-form-field appearance="outline" subscriptSizing="dynamic" *ngIf="field.type === 'select'">
            <mat-label>{{ field.label }}</mat-label>
            <mat-select [(ngModel)]="formModel[field.key]" [name]="field.key" [required]="!!field.required">
              <mat-option value="" disabled hidden>Select {{ field.label }}</mat-option>
              <mat-option *ngFor="let option of field.options" [value]="option">{{ option }}</mat-option>
            </mat-select>
            <mat-error *ngIf="isFieldInvalid(field)">{{ fieldError(field) }}</mat-error>
          </mat-form-field>

          <mat-checkbox *ngIf="field.type === 'checkbox'" [(ngModel)]="formModel[field.key]" [name]="field.key">
            {{ field.label }} - {{ formModel[field.key] ? 'Active' : 'Inactive' }}
          </mat-checkbox>

          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="span-2" *ngIf="field.type === 'textarea'">
            <mat-label>{{ field.label }}</mat-label>
            <textarea matInput rows="4" [(ngModel)]="formModel[field.key]" [name]="field.key" [required]="!!field.required" [maxlength]="field.validation?.maxLength || null" (blur)="normalizeField(field)"></textarea>
            <mat-error *ngIf="isFieldInvalid(field)">{{ fieldError(field) }}</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" subscriptSizing="dynamic" *ngIf="field.type === 'date'">
            <mat-label>{{ field.label }}</mat-label>
            <input matInput [matDatepicker]="fieldDatePicker" [placeholder]="field.label" [(ngModel)]="formModel[field.key]" [name]="field.key" [required]="!!field.required" readonly />
            <mat-datepicker-toggle matIconSuffix [for]="fieldDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #fieldDatePicker></mat-datepicker>
            <mat-error *ngIf="isFieldInvalid(field)">{{ fieldError(field) }}</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" subscriptSizing="dynamic" *ngIf="!field.type || field.type === 'text' || field.type === 'number'">
            <mat-label>{{ field.label }}</mat-label>
            <input
              matInput
              [type]="field.type || 'text'"
              [placeholder]="field.label"
              [(ngModel)]="formModel[field.key]"
              [name]="field.key"
              [required]="!!field.required"
              [min]="field.validation?.min ?? null"
              [max]="field.validation?.max ?? null"
              [minlength]="field.validation?.minLength || null"
              [maxlength]="field.validation?.maxLength || null"
              (blur)="normalizeField(field)"
            />
            <mat-error *ngIf="isFieldInvalid(field)">{{ fieldError(field) }}</mat-error>
          </mat-form-field>
        </ng-template>
      </ng-container>

      <div class="error form-error" *ngIf="error">{{ error }}</div>
      </div>

      <footer class="record-dialog-foot">
        <button mat-button type="button" (click)="closeFormDialog()">Cancel</button>
        <button mat-flat-button color="primary" class="save-btn" type="submit" [disabled]="submitting || !isFormReady()">
          <mat-spinner *ngIf="submitting" diameter="18"></mat-spinner>
          <mat-icon *ngIf="!submitting">save</mat-icon>
          <span>{{ submitting ? 'Saving...' : 'Save' }}</span>
        </button>
      </footer>
    </form>
  </section>
</ng-template>
